import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map, shareReplay } from 'rxjs/operators';
import { exists } from '../../../../../../../../functions/exists';
import type { FireAndFlowerShelfTalkerCardData } from '../../../../../../../../models/shelf-talkers/fire-and-flower-shelf-talker-card-data';
import type { VariantsGroupedByBrand } from '../../../../../../models/variants-grouped-by-brand';
import { ShelfTalkerCardContentViewModel } from '../../shelf-talker-card-content-view-model';

@Injectable()
export class FireAndFlowerShelfTalkerContentViewModel extends ShelfTalkerCardContentViewModel {
  public override data$: Observable<FireAndFlowerShelfTalkerCardData | null>;

  public readonly variantsGroupedByBrandThenSorted$ = this.data$.pipe(
    map(data => data?.getVariantsGroupedByBrandThenSortedBySectionSpecifications()),
    shareReplay({ bufferSize: 1, refCount: true })
  );

  public readonly variantsSplitInto7Rows$ = this.variantsGroupedByBrandThenSorted$.pipe(
    map(sortedByBrand => {
      const twoListsPerRow: [VariantsGroupedByBrand, VariantsGroupedByBrand][] = [];
      for (let i = 0; i < sortedByBrand.length; i += 2) {
        const first = sortedByBrand?.[i];
        const second = sortedByBrand?.[i + 1] ?? null;
        if (exists(first) || exists(second)) {
          twoListsPerRow.push([first, second]);
        }
      }
      return twoListsPerRow?.take(7);
    })
  );
}
